window.addEventListener('load', () => {
    const panel = document.getElementById('buildZoneHeader');
    if (panel) {
        // Parse the data from the template
        const template = panel.querySelector('[data-build-zones]');
        const buildZones = JSON.parse(template.getAttribute('data-build-zones'));

        // Get the input field and the container that displays results
        const inputField = panel.querySelector('input[name="query"]');
        const resultsContainer = panel.querySelector('[data-active]');
        const consultantImageEl = panel.querySelector('[data-consultant-image]');
        const consultantNameEl = panel.querySelector('[data-consultant-name]');
        const consultantPositionEl = panel.querySelector('[data-consultant-position]');
        const consultantPhoneEl = panel.querySelector('[data-consultant-phone]');
        const consultantEmailEl = panel.querySelector('[data-consultant-email]');

        // Function to reset the results container
        const resetResults = () => {
            resultsContainer.setAttribute('data-active', 'false');
            resultsContainer.setAttribute('data-postcode-is-build-zone', 'false');
            resultsContainer.setAttribute('data-valid-consultant', 'false');
            consultantImageEl.querySelector('img').src = '#';
            consultantNameEl.textContent = '#';
            consultantPositionEl.textContent = '#';
            consultantPhoneEl.textContent = '#';
            consultantPhoneEl.href = '#';
            consultantEmailEl.textContent = '#';
            consultantEmailEl.href = '#';
        };

        // Add event listener to the input field
        inputField.addEventListener('input', () => {
            let enteredPostcode = inputField.value.trim();

            // Ensure the number does not exceed 9999
            if (enteredPostcode > 9999) {
                enteredPostcode = 9999;
                inputField.value = enteredPostcode; // Update the input field value
            }

            // Reset the results before validation
            resetResults();

            // Validate the postcode and update the UI
            if (enteredPostcode && !isNaN(enteredPostcode)) {
                const buildZone = buildZones.find(zone => zone.postCode == enteredPostcode);

                if (buildZone) {
                    // Update the active state
                    resultsContainer.setAttribute('data-active', 'true');

                    // Update the postcode build zone validity
                    const isValidBuildZone = buildZone.validBuildZone ? 'true' : 'false';
                    resultsContainer.setAttribute('data-postcode-is-build-zone', isValidBuildZone);

                    // Update consultant details if applicable
                    const hasValidConsultant = buildZone.validBuildZone && buildZone.consultantName ? 'true' : 'false';
                    resultsContainer.setAttribute('data-valid-consultant', hasValidConsultant);

                    if (hasValidConsultant === 'true') {
                        consultantImageEl.setAttribute('data-consultant-image', buildZone.consultantImage ? 'true' : 'false');
                        if (buildZone.consultantImage) {
                            consultantImageEl.querySelector('img').src = buildZone.consultantImage;
                        }
                        consultantNameEl.textContent = buildZone.consultantName;
                        consultantPositionEl.textContent = buildZone.consultantPosition || '#';
                        consultantPhoneEl.textContent = buildZone.consultantPhone || '#';
                        consultantPhoneEl.href = buildZone.consultantPhone ? `tel:${buildZone.consultantPhone}` : '#';
                        consultantEmailEl.textContent = buildZone.consultantEmail || '#';
                        consultantEmailEl.href = buildZone.consultantEmail ? `mailto:${buildZone.consultantEmail}` : '#';
                    }
                } else if (enteredPostcode > 999) {
                    resultsContainer.setAttribute('data-active', 'true');
                    resultsContainer.setAttribute('data-postcode-is-build-zone', 'false');
                    resultsContainer.setAttribute('data-valid-consultant', 'false');
                }

                // Select all inputs with the name 'your_postcode'
                const postcodeInputs = document.querySelectorAll('input[name="your_postcode"]');

                // Loop through each input and set its value
                postcodeInputs.forEach(input => {
                    input.value = enteredPostcode;
                });
            }
        });
    }
});
